import React from 'react';
import { Navigate } from 'react-router-dom';
import { CircuitBoard, Cpu, Zap, Bot, Code, Shield, Database, Terminal } from 'lucide-react';

// Simple security check - you can change this to any secret key you want
const SECRET_KEY = 'your-secret-key-here';

const SecretLogos = () => {
  // Get the key from URL params
  const params = new URLSearchParams(window.location.search);
  const key = params.get('key');

  // Redirect if key doesn't match
  if (key !== SECRET_KEY) {
    return <Navigate to="/" replace />;
  }

  const logos = [
    {
      name: 'Circuit Board (Current)',
      component: <CircuitBoard className="w-16 h-16 text-blue-500" />,
      code: '<CircuitBoard className="w-16 h-16 text-blue-500" />'
    },
    {
      name: 'CPU',
      component: <Cpu className="w-16 h-16 text-blue-500" />,
      code: '<Cpu className="w-16 h-16 text-blue-500" />'
    },
    {
      name: 'Zap',
      component: <Zap className="w-16 h-16 text-blue-500" />,
      code: '<Zap className="w-16 h-16 text-blue-500" />'
    },
    {
      name: 'Bot',
      component: <Bot className="w-16 h-16 text-blue-500" />,
      code: '<Bot className="w-16 h-16 text-blue-500" />'
    },
    {
      name: 'Code',
      component: <Code className="w-16 h-16 text-blue-500" />,
      code: '<Code className="w-16 h-16 text-blue-500" />'
    },
    {
      name: 'Shield',
      component: <Shield className="w-16 h-16 text-blue-500" />,
      code: '<Shield className="w-16 h-16 text-blue-500" />'
    },
    {
      name: 'Database',
      component: <Database className="w-16 h-16 text-blue-500" />,
      code: '<Database className="w-16 h-16 text-blue-500" />'
    },
    {
      name: 'Terminal',
      component: <Terminal className="w-16 h-16 text-blue-500" />,
      code: '<Terminal className="w-16 h-16 text-blue-500" />'
    }
  ];

  const customLogos = [
    {
      name: 'Custom SVG Logo 1',
      component: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-16 h-16 text-blue-500"
        >
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      ),
      code: `<svg
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  className="w-16 h-16 text-blue-500"
>
  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
</svg>`
    },
    {
      name: 'Custom SVG Logo 2',
      component: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-16 h-16 text-blue-500"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2" />
          <line x1="9" y1="9" x2="9.01" y2="9" />
          <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
      ),
      code: `<svg
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  className="w-16 h-16 text-blue-500"
>
  <circle cx="12" cy="12" r="10" />
  <path d="M8 14s1.5 2 4 2 4-2 4-2" />
  <line x1="9" y1="9" x2="9.01" y2="9" />
  <line x1="15" y1="9" x2="15.01" y2="9" />
</svg>`
    }
  ];

  return (
    <div className="min-h-screen bg-slate-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-8">Logo Testing Page</h1>

          {/* Lucide Icons Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold mb-6">Lucide React Icons</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
              {logos.map((logo, index) => (
                <div key={index} className="flex flex-col items-center space-y-4">
                  <div className="p-6 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
                    {logo.component}
                  </div>
                  <h3 className="font-medium text-center">{logo.name}</h3>
                  <pre className="bg-slate-800 text-white p-3 rounded-lg text-sm overflow-x-auto w-full">
                    <code>{logo.code}</code>
                  </pre>
                </div>
              ))}
            </div>
          </section>

          {/* Custom SVG Logos Section */}
          <section>
            <h2 className="text-2xl font-semibold mb-6">Custom SVG Logos</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {customLogos.map((logo, index) => (
                <div key={index} className="flex flex-col items-center space-y-4">
                  <div className="p-6 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
                    {logo.component}
                  </div>
                  <h3 className="font-medium text-center">{logo.name}</h3>
                  <pre className="bg-slate-800 text-white p-3 rounded-lg text-sm overflow-x-auto w-full">
                    <code>{logo.code}</code>
                  </pre>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SecretLogos;